import {
    doc,
    getDoc,
	addDoc,
    setDoc,
    serverTimestamp,
    collection,
    getDocs
}
from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

	const registrarEvidenciaCompatibilidad = ({
		pregunta,
		resultado,
		tiempoRespuesta,
		userId
	}) => ({
	
		preguntaId: Number(pregunta.ID),
	
		fecha: new Date(),
	
		resultado,
	
		tiempoRespuesta,
	
		versionMotor: 2,
	
		origen: pregunta.origen ?? "quiz",
	
		modo: pregunta.modo ?? null,
	
		sesionId: pregunta.sesionId ?? null,
	
		userId,
	
		dificultad:
			Number(
				pregunta.Dificultad_Tema1 || 1
			),
	
		temas: [
	
			pregunta.Tema1,
			pregunta.Tema2,
			pregunta.Tema3,
			pregunta.Tema4
	
		]
			.filter(Boolean)
			.map(Number),
	
		examenes:
			Number(
				pregunta.Examenes
			)
	
	});
	
	const evaluarTemaCompatibilidad = ({

		evidencias,
	
		configTema,
	
		disponibilidad
	
	}) => {
	
		const total = evidencias.length;
	
		const correctas = evidencias.filter(
	
			e => e.resultado === true
	
		).length;
	
		const precision =
			total === 0
				? 0
				: correctas / total;
	
		let pesoMaximo = 0;
	
		let pesoObtenido = 0;
	
		evidencias.forEach(e => {
	
			const peso =
				Number(e.dificultad || 1);
	
			pesoMaximo += peso;
	
			if (e.resultado) {
	
				pesoObtenido += peso;
	
			}
	
		});
	
		const dominio =
			pesoMaximo === 0
				? 0
				: pesoObtenido / pesoMaximo;
	
		let velocidad = null;
	
		if (
			configTema.tiempoEsperado
		) {
	
			const promedio =
	
				evidencias.reduce(
	
					(s,e)=>
	
						s +
	
						(e.tiempoRespuesta || 0),
	
					0
	
				)
	
				/
	
				Math.max(total,1);
	
			velocidad =
	
				configTema.tiempoEsperado
	
				/
	
				Math.max(promedio,1);
	
		}
	
		const persistencia = 1;
	
		const cobertura =
	
			disponibilidad.totalPreguntas
	
				?
	
				Math.min(
	
					1,
	
					total /
	
					disponibilidad.totalPreguntas
	
				)
	
				:
	
				1;
	
		const confianza =
	
			Math.min(
	
				1,
	
				total / 20
	
			);
	
		const indice =
	
			precision * 0.40 +
	
			dominio * 0.25 +
	
			persistencia * 0.20 +
	
			(velocidad ?? 1) * 0.10 +
	
			cobertura * 0.05;
	
		const nivelActual =
	
			Math.max(
	
				0,
	
				Math.min(
	
					5,
	
					Math.round(
	
						indice * 5
	
					)
	
				)
	
			);
	
		const nivelObjetivo =
	
			configTema.nivelObjetivo ?? 3;
	
		const causas = [];
	
		if (precision < 0.7)
			causas.push("precision");
	
		if (dominio < 0.7)
			causas.push("dominio");
	
		return {
	
			nivelActual,
	
			nivelObjetivo,
	
			suficiente:
	
				nivelActual >=
	
				nivelObjetivo,
	
			indice,
	
			precision,
	
			persistencia,
	
			velocidad,
	
			cobertura,
	
			confianza,
	
			causas
	
		};
	
	};

const actualizarProgresoTemas = async ({
	userId,
	correcta,
	pregunta
}) => {

	try {

		const temas = [
			pregunta?.Tema1,
			pregunta?.Tema2,
			pregunta?.Tema3,
			pregunta?.Tema4
		]
		.filter(Boolean)
		.map(Number);
				
		for (const temaId of temas) {
			const ref = doc(
				db,
				"progreso_temas",
				`${userId}_${temaId}`
			);
			
			try {

				const snap = await getDoc(ref);
			
			} catch (error) {
			
				console.error(
					"ERROR GETDOC"
				);
			
				console.error(error);
			
				console.error(error.code);
			
				console.error(error.message);
			
				throw error;
			}

			const snap =
				await getDoc(ref);
			
				let data = {

					userId,
				
					temaId,
				
					evidencias: [],
				
					nivelActual: 0,
				
					nivelObjetivo: 0,
				
					suficiente: false,
				
					indice: 0,
				
					precision: 0,
				
					persistencia: 0,
				
					velocidad: null,
				
					cobertura: 0,
				
					confianza: 0,
				
					causas: [],
				
					ultimaEvaluacion: null
				
				};

			if (snap.exists()) {

				data = snap.data();
			}

			// ===================================
// CONFIGURACIÓN DEL TEMA EN FIRESTORE
// ===================================

let configuracionTema = null;

if (pregunta?.componenteId) {

    const relacionesSnap =
        await getDocs(
            collection(
                db,
                "tema_componente"
            )
        );

		configuracionTema =
		relacionesSnap.docs
			.map(d => d.data())
			.find(r =>
	
				Number(r.TemaID) === temaId &&
	
				Number(r.Componentes) ===
				Number(pregunta.componenteId)
	
			);

}

// ===================================
// REGISTRAR EVIDENCIA
// ===================================

const evidencia = registrarEvidenciaCompatibilidad({

    pregunta,

    resultado: correcta,

    tiempoRespuesta:
        pregunta.tiempoRespuesta ?? 0,

    userId

});

// Guardar evidencia en memoria
data.evidencias = [

    ...(data.evidencias || []),

    evidencia

];

// ===================================
// CONTEXTO DE EVALUACIÓN
// ===================================

const contexto = {

    evidencias: data.evidencias,

    configTema: {

        nivelObjetivo:

            configuracionTema?.NivelObjetivo ??

            data.nivelObjetivo ??

            3,

        tiempoEsperado:

            configuracionTema?.TiempoEsperado ??

            null

    },

    disponibilidad: {

        totalPreguntas:

            data.totalPreguntasTema ??

            data.evidencias.length

    }

};

// ===================================
// EVALUAR
// ===================================

const evaluacion = evaluarTemaCompatibilidad(

    contexto

);
				
Object.assign(

	data,

	evaluacion

);

data.ultimaEvaluacion =
	serverTimestamp();
				
				await setDoc(
					ref,
					data,
					{
						merge: true
					}
				);

				await addDoc(

					collection(
				
						db,
				
						"historial_temas"
				
					),
				
					{
				
						userId,
				
						temaId,
				
						fecha:
				
							serverTimestamp(),
				
						nivelActual:
				
							data.nivelActual,
				
						nivelObjetivo:
				
							data.nivelObjetivo,
				
						suficiente:
				
							data.suficiente,
				
						indice:
				
							data.indice,
				
						precision:
				
							data.precision,
				
						persistencia:
				
							data.persistencia,
				
						velocidad:
				
							data.velocidad,
				
						cobertura:
				
							data.cobertura,
				
						confianza:
				
							data.confianza,
				
						componenteId:
				
							pregunta.componenteId
				
							??
				
							null
				
					}
				
				);

				return data;
				
		}

	} catch (error) {

		console.error(
			"ERROR actualizarProgresoTemas"
		);
	
		console.error(error);
	
		console.error(
			error.code
		);
	
		console.error(
			error.message
		);
	}
};

export default actualizarProgresoTemas;